import NediStatusChip from '../nedi/NediStatusChip';
import { getLocale, t } from '../../i18n';
import './OfflineBadge.css';

/** Format IDB cachedAt ISO for the offline badge (active locale). */
export function formatOfflineCachedAt(iso) {
  if (!iso || typeof iso !== 'string') return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  const locale = getLocale() === 'pt-BR' ? 'pt-BR' : getLocale();
  return date.toLocaleString(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Compact offline indicator for scope bar / WorkspaceStatus.
 * Visible when browser offline or map-data came from IDB hydrate.
 */
function OfflineBadge({ cachedAt, compact = false }) {
  const stamped = formatOfflineCachedAt(cachedAt);
  const label = stamped
    ? t('web.offline.badge.cached', { when: stamped })
    : t('web.offline.badge');

  return (
    <NediStatusChip
      compact={compact}
      className={`av-offline-badge${compact ? ' av-offline-badge--compact' : ''}`}
      title={label}
    >
      {label}
    </NediStatusChip>
  );
}

export default OfflineBadge;
